module.exports = __webpack_public_path__ + "img/page2-one.8f903412.png";